<template>
  
    <v-card flat>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      <h2 class>{{ $t('ebook.delete-report-draft') }}</h2>

      <p>{{$t('ebook.delete-report-warning-text')}}</p>
      <v-expand-transition v-if="reports.length > 0">
        <v-list two-line>
          <v-list-item-group>
            <template v-for="(item,index) in reports">
              <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
              <v-list-item :key="`emp-${index}`">
                <v-list-item-avatar>
                  <v-icon>$sl-notes</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('labels.draft')}}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t('labels.created')}} {{dateFormat(item.createdAt)}}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon
                    @click="deleteReportClick(item.bookId, item.id, dateFormat(item.createdAt))"
                  >$sl-delete</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-expand-transition>
      <ModalBase
          :show="showModal"
          maxWidth="400px"
          :title="$t('ebook.delete-report-text')"
          cancelIcon="$sl-cancel"
          submitIcon="$sl-delete"
          :cancelText="$t('labels.cancel')"
          :submitText="$t('ebook.delete')"
          @close="closeModal"
          @cancel="closeModal"
          @submit="deleteReport(selectedReport.bookId, selectedReport.id, selectedReport.date)"
          :outlinedCancel="false">
            <template v-slot:text>
              {{ $t('ebook.delete-report-text2', { date: selectedReport.date }) }}
            </template>
      </ModalBase>

    </v-card>  
</template>





<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import ModalBase from '@/components/Common/ModalBase';
import ModalBaseMixin from "@/components/mixins/ModalBaseMixin";

const SugarDate = require('sugar/date')
// @group Ebook
// Styled EbookReportDeleteModal component
export default {
  name: 'EbookReportDeleteModal',

  mixins: [ModalBaseMixin],

  props: {
    //has reports
    reports: Array
  },

  data: () => ({
    reportId: -1,
    selectedReport: {}
  }),

  components: {
    ModalBase
  },

  created() {},

  watch: {},

  filters: {},
  methods: {
    deleteReportClick(bookId, id, date){
      this.selectedReport.bookId=bookId
      this.selectedReport.id=id
      this.selectedReport.date=date
      this.showModal=true      
    },
    deleteReport(bookId, id, date) {
      // const res = await this.$dialog.confirm({
      //   title: this.$t('ebook.delete-report-text'),
      //   text: this.$t('ebook.delete-report-text2', {
      //     date: date
      //   }),
      //   actions: [
      //     {text: this.$i18n.t('labels.no'), key: false, icon: '$sl-cancel', outlined: true},
      //     {text: this.$i18n.t('labels.yes'), key: true, icon: '$sl-save'}
      //   ]
      // })
      this.showModal=false
      // if (res == true) {
        if (id && id > 0) {
          let params = {bookId: bookId, reportId: id}
          // Fire close
          // @arg The argument is a object representing report
          this.$emit('close', params)
        } else {
          return
        }      
    },
    dateFormat(date) {
      if (date && date != '') return SugarDate.Date(date).format('%Y-%m-%d %H:%M')
      else {
        return ''
      }
    }
  }
}
</script>

